module.exports = __webpack_public_path__ + "media/images/Group 9-a5f9cec91d369b35cd7eafe2bba768ce.png";